import React, {useEffect, useState} from 'react';
import {Route} from 'react-router-dom';
import {FormattedHTMLMessage, FormattedMessage, useIntl} from "react-intl";
import ReactFloater from "react-floater";
import MerlinIcon from "./MerlinIcon";
import GuideAssistant, {LIFECYCLE} from "../../refactor/guideAssistant/GuideAssistant";
import getSurveyPageSteps from "../../utils/guideAssistantSteps/getSurveyPageSteps";
import {useAppContext} from "../../AppContext";
import ReactSVG from "react-svg";
import {getMessageValue} from "@ignitesales/neuro-application/src/i18n/messageUtil";
import {ACTIONS} from "react-joyride";

let isLoadingTimeout;

const MerlinSurveyAssistant = ({ currentPage, onActionCompleted, processingNavigation }) => {
  const intl = useIntl();
  const appContext = useAppContext();
  const [ showMerlinTooltip, setShowMerlinTooltip ] = useState(false);
  const [ pageDemoProps, setPageDemoProps ] = useState({});
  const [ isLoading, setIsLoading ] = useState(false);
  const pageKey = currentPage?.page?.key || '';
  const manuallyRunDemoButtonText = getMessageValue(intl.locale, `${pageKey}.merlin.tooltip.btnText`);
  const pageSteps = pageKey ? getSurveyPageSteps(pageKey) : [];

  useEffect(() => {
    if(processingNavigation){
      setShowMerlinTooltip(false);
      setIsLoading(true);
      setPageDemoProps({});
    }else{
      clearTimeout(isLoadingTimeout);
      isLoadingTimeout = setTimeout(() => setIsLoading(false), 1250);
    }
  }, [processingNavigation])

  const renderMerlinTooltip = () => {
    return <div className="guideAssistantTooltip merlinTooltip">
      <div className="guideAssistantTooltip__content">
        <FormattedHTMLMessage id={`${pageKey}.merlin.tooltip`} />
      </div>
      <div className='guideAssistantTooltip__footer'>
        <button className="gaBtn gaBtn--skip" onClick={() => setShowMerlinTooltip(false)}>
          <FormattedMessage id="assistant.skip" />
        </button>
        {manuallyRunDemoButtonText &&
        <button className="gaBtn gaBtn--next" onClick={runMerlinDemo}>
          <FormattedMessage id={`${pageKey}.merlin.tooltip.btnText`}/>
        </button>
        }
      </div>
    </div>
  };

  const runMerlinDemo = () => {
    setShowMerlinTooltip(false);
    setPageDemoProps({
      ...pageDemoProps,
      run: true
    });
  }

  const onGuideAssistantChange = data => {
    //We want to record an action when the demo is run, but not on the isCustomer page since that is automatic
    const { lifecycle, action } = data;
    if( (action === ACTIONS.STOP || action === ACTIONS.RESET) && pageDemoProps?.run ) {
      setPageDemoProps({
        ...pageDemoProps,
        run: false
      })
    }
    if( lifecycle === LIFECYCLE.COMPLETE ){
      onActionCompleted(`guideAssistant.${pageKey}`);
    }
  };

  const onMerlinIconClick = () => {
    onActionCompleted(`merlinClicked.${pageKey}`);
    setShowMerlinTooltip(!showMerlinTooltip);
  }

  return (
    <Route path={["/guide/spa/:uuid/:path/:page"]} children={({match}) => {
      return match && currentPage ? <div>
        { isLoading ?
          <div className="pageIsProcessing">
            <ReactSVG src="/classpath/assets/images/loading.svg" />
          </div> : null
        }
        <span className="merlinIconText" onClick={onMerlinIconClick}><FormattedMessage id="merlinIconText" /></span>
        <MerlinIcon id={appContext.merlinSurveyId} pulseForever={true} onClick={onMerlinIconClick} />
        { showMerlinTooltip ?
          <ReactFloater
            target={`#${appContext.merlinSurveyId} .merlin__icon`}
            placement="bottom"
            offset={5}
            component={renderMerlinTooltip}
            disableAnimation={true}
            open={true}
            style={{zIndex: 9999}}
          /> : null
        }
        { processingNavigation ? null :
          <GuideAssistant
            continuous={true}
            delay={1250}
            enforceCache={true}
            floaterProps={{disableAnimation: true}}
            id={`surveyPage-${pageKey}`}
            onChange={onGuideAssistantChange}
            showSkipButton={true}
            steps={ (!manuallyRunDemoButtonText || pageDemoProps?.run) ? pageSteps : [] }
            {...pageDemoProps}
          />
        }
      </div> : null
    }}
    />
  )
};

export default MerlinSurveyAssistant;
